import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-page-header",
  imports: [MatButtonModule, MatIconModule, TranslateModule, CommonModule],
  templateUrl: "./page-header.component.html",
  styleUrl: "./page-header.component.scss"
})
export class PageHeaderComponent {
  @Input() title: string;
  @Input() btnLabel: string;
  @Input() btnIcon: string = "add_box";
  @Input() isBtnDisabled = false;
  @Input() onClick: () => void;
  @Input() hideButton: boolean;
}
